import { patientFormTemplateBaseModel } from './crud';

export * from './types';

export const usePatientFormTemplatesById =
  patientFormTemplateBaseModel.fetchById();
export const usePatientFormTemplatesByIds =
  patientFormTemplateBaseModel.fetchByIds();
export const usePatientFormTemplatesMany =
  patientFormTemplateBaseModel.fetchMany();
export const usePatientFormTemplatesCount =
  patientFormTemplateBaseModel.count();
export const usePatientFormTemplatesManyInfiniteQuery =
  patientFormTemplateBaseModel.fetchPaginated();
export const usePatientFormTemplatesUpdateOne =
  patientFormTemplateBaseModel.edit();
export const usePatientFormTemplatesCreateOne =
  patientFormTemplateBaseModel.create();
export const usePatientFormTemplatesRemoveOne =
  patientFormTemplateBaseModel.delete();
export const usePatientFormTemplatesRemoveByIds =
  patientFormTemplateBaseModel.deleteByIds();

export const usePatientFormTemplatesByIdV2 =
  patientFormTemplateBaseModel.fetchByIdV2();
export const usePatientFormTemplatesByIdsV2 =
  patientFormTemplateBaseModel.fetchByIdsV2();
export const usePatientFormTemplatesManyV2 =
  patientFormTemplateBaseModel.fetchManyV2();
export const usePatientFormTemplatesCountV2 =
  patientFormTemplateBaseModel.countV2();
export const usePatientFormTemplatesManyInfiniteQueryV2 =
  patientFormTemplateBaseModel.fetchPaginatedV2();
export const usePatientFormTemplatesUpdateOneV2 =
  patientFormTemplateBaseModel.editV2();
export const usePatientFormTemplatesCreateOneV2 =
  patientFormTemplateBaseModel.createV2();
export const usePatientFormTemplatesRemoveOneV2 =
  patientFormTemplateBaseModel.deleteV2();
export const usePatientFormTemplatesRemoveByIdsV2 =
  patientFormTemplateBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const usePatientFormTemplateById =
  patientFormTemplateBaseModel.fetchById();
export const usePatientFormTemplateByIds =
  patientFormTemplateBaseModel.fetchByIds();
export const usePatientFormTemplateMany =
  patientFormTemplateBaseModel.fetchMany();
export const usePatientFormTemplateCount = patientFormTemplateBaseModel.count();
export const usePatientFormTemplatePagination =
  patientFormTemplateBaseModel.fetchPaginated();
export const usePatientFormTemplateUpdateOne =
  patientFormTemplateBaseModel.edit();
export const usePatientFormTemplateCreateOne =
  patientFormTemplateBaseModel.create();
export const usePatientFormTemplateRemoveOne =
  patientFormTemplateBaseModel.delete();
export const usePatientFormTemplateRemoveByIds =
  patientFormTemplateBaseModel.deleteByIds();

export const usePatientFormTemplateByIdV2 =
  patientFormTemplateBaseModel.fetchByIdV2();
export const usePatientFormTemplateByIdsV2 =
  patientFormTemplateBaseModel.fetchByIdsV2();
export const usePatientFormTemplateManyV2 =
  patientFormTemplateBaseModel.fetchManyV2();
export const usePatientFormTemplateManyByContentRangeV2 =
  patientFormTemplateBaseModel.fetchManyByContentRangeV2();
export const usePatientFormTemplateCountV2 =
  patientFormTemplateBaseModel.countV2();
export const usePatientFormTemplatePaginationV2 =
  patientFormTemplateBaseModel.fetchPaginatedV2();
export const usePatientFormTemplateUpdateOneV2 =
  patientFormTemplateBaseModel.editV2();
export const usePatientFormTemplateCreateOneV2 =
  patientFormTemplateBaseModel.createV2();
export const usePatientFormTemplateRemoveOneV2 =
  patientFormTemplateBaseModel.deleteV2();
export const usePatientFormTemplateRemoveByIdsV2 =
  patientFormTemplateBaseModel.deleteByIdsV2();
